export const addressHasChanged = (address1, address2) => {
  if (!address1 && !!address2) return true;
  if (!address2 && !!address1) return true;
  if (!address1 && !address2) return false;
  if (address1.addressLine1 !== address2.addressLine1) return true;
  if (address1.addressLine2 !== address2.addressLine2) return true;
  if (address1.addressLine3 !== address2.addressLine3) return true;
  if (address1.town !== address2.town) return true;
  if (address1.county !== address2.county) return true;
  if (address1.postCode !== address2.postCode) return true;
  return false;
};

export const buildAddressString = outlet => {
  if (!outlet) return '';
  if (!outlet.address) return '';
  const keys = [
    'addressLine1',
    'addressLine2',
    'addressLine3',
    'town',
    'county',
    'postcode'
  ];
  let str = '';
  for (let i = 0; i < keys.length; i++) {
    if (outlet.address[keys[i]]) {
      if (str !== '') str += ', ';
      str += outlet.address[keys[i]];
    }
  }
  return str;
};
